<template>
 <div :class="windowClass">
        <v-row no-gutters>
            <v-col md="7" class="pa-1">
                    <v-card class="pa-2">
                        <v-card-title>
                           <v-icon large left color="secondary">mdi-fish</v-icon> AVAILABLE SUPPLIES  
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="selected_date"
                            type="date"
                            append-icon="mdi-calendar"
                            label="Select Date"
                            @change="getSupplies()"
                            single-line
                            hide-details
                        ></v-text-field>
                        <!-- <v-icon right color="success" class="mt-5 ml-5" large @click="kind={}, state='new', kindform=true">mdi-plus-box</v-icon>  -->
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :items-per-page="25"
                                :items="SUPPLIES"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                            {{ item.name }}
                                            </td>
                                            <td>
                                            {{ item.description }}
                                            </td>
                                            <td>{{ item.fishcar }}</td>
                                            <td>
                                                <v-switch
                                                class="mt-0"
                                                small
                                                v-model="item.status"
                                                @change="kind = item, UpdateStatus()"
                                                color="success"
                                                value="available"
                                                hide-details
                                                ></v-switch>
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
            <v-col md="5" class="pa-1">
                    <v-card class="pa-2">
                        <v-card-title>
                           <v-icon large left color="secondary">mdi-fish</v-icon> MANAGE FISH KINDS  
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="kind_search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-icon right color="success" class="mt-5 ml-5" large @click="kind={}, state='new', kindform=true">mdi-plus-box</v-icon> 
                        </v-card-title>
                             <v-data-table
                                class="va-table"
                                dense
                                :headers="kindheaders"
                                :items-per-page="25"
                                :search="kind_search"
                                :items="kinds"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                            <v-icon small left color="warning" @click="kind=item, state='update', kindform=true">mdi-pencil</v-icon> 
                                            {{ item.name }}</td>
                                            <td>
                                            {{ item.description }}
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
        </v-row>
        <va-kind-form :show="kindform" :kind="kind" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
import {
  mapMutations
} from 'vuex'
  export default {
    mixins: [API_MIXINS],
    data: () => ({
        kindform: false,
        kind_search:'',
        kind:{},
        state:'new',
        kinds:[],
         kindheaders: [
            { text: 'Name', value: 'name'},
            { text: 'Description', value: 'description'}
        ],
        headers: [
            { text: 'Name'},
            { text: 'Description'},
            { text: 'Fishcar'},
             { text: 'Status'}
        ],
        selected_date: ''
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.selected_date = this.$moment().format('YYYY-MM-DD')
          this.getKinds()
          this.getSupplies()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      SUPPLIES() {
        return this.$store.state.supplies
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      formEvent(data){
          this.kindform = false
          if(data.action != 'close') {
              this.kind = data.kind
              this.SaveKind()
          }
      },
      UpdateStatus: function() {
            if(this.kind.status == null)
                this.kind.status = "not available"

            this.$http.post("product/update", JSON.stringify(this.kind)).then(response => {
                response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
                this.setAlertText(response.data.message)
                this.setAlert(true)
            }).catch(e => {
                console.log(e.data)
            })
        },
      getSupplies() { 
        this.GET_SUPPLIES(this.selected_date, this.selected_date)
     },
      getKinds() {
           this.$http.post("category/list", JSON.stringify({})).then(response => {
               response.data.data != null?this.kinds = response.data.data:this.kinds=[]
          }).catch(e => {
           console.log(e)
         })
      },
      SaveKind() {
        let method = 'category/new'
        this.state != 'new'?method='category/update':method = 'category/new'
        this.$http.post(method, JSON.stringify(this.kind)).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getKinds()
        }).catch(e => {
        console.log(e)
        })
     }
    }
  }
</script>